export type ResponseErrorException = ReturnType<typeof createResponseError>;

export const isResponseErrorException = (value: unknown): value is ResponseErrorException =>
  typeof value === "object" && value !== null && "name" in value && value.name === "ResponseError";
export const createResponseError = (error: unknown) => ({
  name: "ResponseError",
  error,
});

export const unparseableResponseError = (targetUrl: string, exception: unknown) =>
  new Error(`
      Response could not be parsed as JSON

      ${exception as string}

      URL: [${targetUrl.slice(0, 128)}...]
      `);

export const containsMessageAttribute = (
  value: unknown,
): value is {
  message: string;
} => typeof value === "object" && value !== null && "message" in value;

export const unexpectedError = (exception: unknown) => {
  const hasErrorMessage = containsMessageAttribute(exception);

  return new Error(`
      Unexpected error
      ${hasErrorMessage && exception.message.length > 0 ? exception.message : "-- no error message --"}
      `);
};
